import { render, staticRenderFns } from "./WhitelistOneShot.vue?vue&type=template&id=5b88ae1a&scoped=true&"
import script from "./WhitelistOneShot.vue?vue&type=script&lang=ts&"
export * from "./WhitelistOneShot.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelistOneShot.vue?vue&type=style&index=0&id=5b88ae1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88ae1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VSelect,VSkeletonLoader,VTextField})
